import { useEffect, useState } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { mapSailor } from "../util/mapSailor";
import config from "@poseidon/utils/config";

export const useAgreementSailor = ({ applicationId, sailorId }) => {
  const [agreementSailor, setAgreementSailor] = useState();
  const [value, loading, error] = useDocument(
    doc(
      db,
      config.SaltCollection.Application,
      applicationId,
      "agreementSailors",
      sailorId
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  const notFound = !loading && value && !value.exists();
  useEffect(() => {
    const run = async () => {
      if (value?.exists()) {
        const sailor = await mapSailor(value);
        setAgreementSailor(sailor);
      }
    };
    run();
  }, [value, sailorId]);
  return { agreementSailor, loading, error, notFound };
};
